import "core-js/modules/es6.function.name";
import "core-js/modules/es7.array.includes";
import "core-js/modules/es6.string.includes";
import _Promise from "/Users/jhonsem/Work/FaceAnalysis_Web/node_modules/@babel/runtime-corejs2/core-js/promise";
import "core-js/modules/es6.regexp.split";
import "core-js/modules/es6.array.find";
import store from "@/store/index";
import * as types from "@/store/constants/types";
import { CDN_BASE_URL } from "@/config/config";
import { judgeLocalVideoAndConfig, judgeAppSurportVibrate } from "@/utils/judgeVersion";
import { isIos, iosVersion } from "@/utils/lodash";
var GeneralUtilsHelper = {
  isSubsOffer: function isSubsOffer(offer_id) {
    //判断这个offer是否是订阅类型的offer
    try {
      var offer_map = store.getters[types.GETTER_OFFER_MAP];
      var offer = offer_map[offer_id];
      var result;

      if (offer.kind.indexOf("vip") > -1) {
        return true; // result = !GeneralUtilsHelper.getIapTypeByServiceOffer(offer.offer_id);
      } else {
        result = offer.hasOwnProperty("subscription");
      }

      return result;
    } catch (error) {
      return false;
    }
  },
  // 通过offerId, type获取product_id  type对应iap paypal stripe
  getProductIdByOfferId: function getProductIdByOfferId(offer_id, type) {
    try {
      var offer_map = store.getters[types.GETTER_OFFER_MAP];
      var price_map = store.getters[types.GETTER_PRICE_MAP];
      var offer = offer_map[offer_id];
      var price_id = offer && offer.price_id;
      var price = price_id && price_map[price_id];
      var product_id = price && type && price[type] && price[type].product_id;
      return product_id;
    } catch (error) {
      return false;
    }
  },
  getProductIdArray: function getProductIdArray() {
    try {
      var product_id_array = [];
      var price_map = store.getters[types.GETTER_PRICE_MAP];

      for (var value in price_map) {
        if (price_map[value].iap && price_map[value].iap.product_id) {
          product_id_array.push(price_map[value].iap.product_id);
        }
      }

      console.log("getProductIdArray:", product_id_array);
      return product_id_array;
    } catch (error) {
      return [];
    }
  },
  // 判断serviceList里面是否有有效的vip
  isVip: function isVip() {
    var currentTime = new Date().getTime();
    var serviceList = store.getters[types.GETTER_SERVICE_LIST]; // console.log("serviceList", serviceList);
    // return true;

    return serviceList.find(function (v) {
      return v.sub_expire_timestamp > currentTime;
    });
  },
  // 判断是否是renew
  isRenew: function isRenew() {
    var serviceList = store.getters[types.GETTER_SERVICE_LIST];
    return serviceList && serviceList.length > 0 && !GeneralUtilsHelper.isVip();
  },
  getPriceByOfferId: function getPriceByOfferId(offer_id) {
    var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "iap";

    try {
      var offer_map = store.getters[types.GETTER_OFFER_MAP];
      var price_map = store.getters[types.GETTER_PRICE_MAP];
      var offer = offer_map[offer_id];
      var price_id = offer && offer.price_id;
      var price = price_id && price_map[price_id];
      return price && type && price[type] && price[type].price;
    } catch (error) {
      return "";
    }
  },
  getTimeStamp: function getTimeStamp() {
    var time = new Date();
    return time.getDate() + " " + time.toDateString().split(" ")[1].toUpperCase() + " " + time.getFullYear();
  },
  getVideoFileUrl: function getVideoFileUrl(name) {
    var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "local";
    var forceType = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
    //  age_shutter.mp4  beauty_contest.mp4 future_baby.mp4 love_compatibility.mp4
    //gender_switch_vip.mp4  personality_future_vip.mp4
    // palm_print.mp4  vip_all.mp4   home_age_shutter.mp4   总共9种key name
    //线上视频，type === online
    return new _Promise(function (resolve, reject) {
      if (isIos() && iosVersion() && iosVersion().includes("9")) {
        type = "online";
      }

      if (type === "local" && judgeLocalVideoAndConfig()) {
        Cordova.exec(function (res) {
          console.info("GetLocalFiles:", res);
          var findFile = res.find(function (file) {
            return file.name === name;
          });

          if (findFile) {
            window.resolveLocalFileSystemURL(findFile.path_url, function (entry) {
              console.log("cdvfile URI: " + entry.toInternalURL());
              resolve(entry.toInternalURL());
            });
          } else {
            //没有找到,如果是强制类型，则返回false
            if (forceType) {
              resolve(false);
            } else {
              resolve(CDN_BASE_URL.video + "/" + name);
            }
          }
        }, function (err) {
          resolve(CDN_BASE_URL.video + "/" + name);
        }, "ThirdPartyPlugin", "GetLocalFiles", []);
      } else {
        resolve(CDN_BASE_URL.video + "/" + name);
      }
    });
  },

  /*
    开启手机震动
    iosParam 0、1、2 、1519、1520、1521，有6种不同的震动方式,震动逐渐加强
    androidParam  [11,22,-1] 第一个参数震动时间ms，第二个参数震动强度0～255，
    [[111,100,222], 202, -1]写数组表示震动111ms，停100ms，再震动222ms，震动强度202，震动强度也可以写数组
  */
  vibratePhone: function vibratePhone(iosParam, androidParam) {
    // console.log('judgeAppSurportVibrate()',judgeAppSurportVibrate())
    if (judgeAppSurportVibrate()) {
      try {
        if (isIos()) {
          navigator.vibrate(iosParam);
        } else {
          navigator.vibrate.vibrate(androidParam);
        }
      } catch (err) {}
    }
  }
};
export default GeneralUtilsHelper;